import { GMBSimpleModel } from "@/utils/google/GMB/make-gmb-data/gmb-simple-model";
import { GMBWithComparisionData } from "@/utils/google/GMB/make-gmb-data/gmb-with-comparision-data";
import { GMBWithComparisionDataUpdated } from "@/utils/google/GMB/make-gmb-data/gmb-with-comparision-data-updated";
import { GMB_DATA_ENUM } from "@/enums/gmbData.enum";

export class GMBBuilderDirector {
  constructor() {
    this.gbmData = null;
    this.gbmDataOld = null;
  }

  async createGMBModelAndDataAsync(gmbModel, config, downloadFileExtension) {
    const exportId = await gmbModel.makeGmbAsync(config, downloadFileExtension);
    this.gbmData = gmbModel.returnGmb();
    return exportId;
  }

  async createGMBModelAndData(gmbModel, config, downloadFileExtension) {
    await gmbModel.makeGmb(config, downloadFileExtension);
    this.gbmData = gmbModel.returnGmb();
  }

  async createGMBDataAsync(gmbDataType, config, downloadFileExtension = null) {
    switch (gmbDataType) {
      case GMB_DATA_ENUM.GMB_SIMPLE_DATA: {
        const gmbSimple = new GMBSimpleModel();
        return this.createGMBModelAndDataAsync(
          gmbSimple,
          config,
          downloadFileExtension
        );
      }
      case GMB_DATA_ENUM.GMB_WITH_COMPARISON_DATA: {
        const gmbWithComparision = new GMBWithComparisionDataUpdated();
        return this.createGMBModelAndDataAsync(
          gmbWithComparision,
          config,
          downloadFileExtension
        );
      }
    }
  }

  async createGMBData(gmbDataType, config, downloadFileExtension = null) {
    switch (gmbDataType) {
      case GMB_DATA_ENUM.GMB_SIMPLE_DATA: {
        const gmbSimple = new GMBSimpleModel();
        await this.createGMBModelAndData(
          gmbSimple,
          config,
          downloadFileExtension
        );
        break;
      }
      case GMB_DATA_ENUM.GMB_WITH_COMPARISON_DATA: {
        const gmbWithComparision = new GMBWithComparisionDataUpdated();
        await this.createGMBModelAndData(
          gmbWithComparision,
          config,
          downloadFileExtension
        );
        break;
      }
    }
  }

  async createGMBDataOld(gmbDataType, config, downloadFileExtension = null) {
    switch (gmbDataType) {
      case GMB_DATA_ENUM.GMB_SIMPLE_DATA: {
        const gmbSimple = new GMBSimpleModel();
        await gmbSimple.makeGmbOld(config, downloadFileExtension);
        this.gbmDataOld = gmbSimple.returnGmbOld();
        break;
      }
      case GMB_DATA_ENUM.GMB_WITH_COMPARISON_DATA: {
        const gmbWithComparision = new GMBWithComparisionData();
        await gmbWithComparision.makeGmbOld(config, downloadFileExtension);
        this.gbmDataOld = gmbWithComparision.returnGmbOld();
        break;
      }
    }
  }

  returnGMBData() {
    return this.gbmData;
  }
  returnGMBDataOld() {
    return this.gbmDataOld;
  }
}
